
import axios from '../plugins/axiosPlugins'
import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

/**
 * 捐赠平台 
 * @returns 
 */
 export const addPointsDonation = (data: any): Promise<any> => {
    return axios.post(`${baseURL}/PointsDonation`, data);
}


/**
 * 捐赠平台 - 支付预付信息
 * @returns 
 */
 export const beforehandPayDonatio = (data: any): Promise<any> => {
    return axios.post(`${baseURL}/PointsDonation/BeforehandPayDonatio`, data);
}

/**
 * 我的捐献 
 * @returns 
 */
 export const MyDonniton = (): Promise<any> => {
    return axios.get(`${baseURL}/Donation/MyDonniton`);
}

/**
 * 我的捐献列表
 * @returns 
 */
 export const MyDonnitonLst = (pageNum:number,pageSize:number): Promise<any> => {
    return axios.get(`${baseURL}/Donation/MyDonnitonLst?pageNum=${pageNum}&pageSize=${pageSize}`);
}


/**
 * 我的积分捐献列表
 * @returns 
 */
 export const MyDonnitonLightUpLst = (pageNum:number,pageSize:number): Promise<any> => {
    return axios.get(`${baseURL}/Donation/MyDonnitonLightUpLst?pageNum=${pageNum}&pageSize=${pageSize}`);
}

/**
 * 捐献记录列表
 * @returns 
 */
 export const PointsDonationLst = (pageNum:number,pageSize:number): Promise<any> => {
    return axios.get(`${baseURL}/PointsDonation?pageNum=${pageNum}&pageSize=${pageSize}`);
}

/**
 * 我的捐献的项目
 * @returns 
 */
 export const MyDonnitonAndSupplies = (): Promise<any> => {
    return axios.get(`${baseURL}/Donation/MyDonnitonAndSupplies`);
}

/**
 * 我的捐献的项目列表
 * @returns 
 */
 export const MyDonnitonAndSuppliesLst = (donntionType:number,pageNum:number,pageSize:number): Promise<any> => {
    return axios.get(`${baseURL}/Donation/MyDonnitonAndSuppliesLst?donntionType=${donntionType}&pageNum=${pageNum}&pageSize=${pageSize}`);
}

/**
 * 所有捐赠列表
 * @returns 
 */
 export const ALLDonnitonLightUpLst = (pageNum:number,pageSize:number): Promise<any> => {
    return axios.get(`${baseURL}/Donation/ALLDonnitonLightUpLst?pageNum=${pageNum}&pageSize=${pageSize}`);
}

/**
 * 所有捐赠物资列表
 * @returns 
 */
 export const ALLSuppliesLst = (pageNum:number,pageSize:number): Promise<any> => {
    return axios.get(`${baseURL}/Donation/ALLSuppliesLst?pageNum=${pageNum}&pageSize=${pageSize}`);
}


